// Modified based on default theme
export default {
    scheme: 'github',
    author: 'defman21',
    base00: '#181818',
    base01: '#282828',
    base02: '#333333',
    base03: '#969896',
    base04: '#c8c8fa',
    base05: '#e8e8e8',
    base06: '#f5f5f5',
    base07: '#ffffff',
    base08: '#a71d5d',
    base09: '#ed6a43',
    base0A: '#f7ca88',
    base0B: '#a1b56c',
    base0C: '#0086b3',
    base0D: '#183691',
    base0E: '#795da3',
    base0F: '#ed6a43',
};
